import { useTranslation } from 'next-i18next';

// import { useRouter } from 'next/router';
import { useCallback, useState } from 'react';
import { useMutation } from 'react-query';

import { useLoadingStore } from '@stores/useLoadingStore';

import { ActionSheetOption, KebabMenu } from '@components/common/ActionSheet';
import Story, {
  StoryProps,
  storyActionCSS,
  storyWrapCSS,
} from '@components/stories/Story';

import { unlikeStory } from '@api/story';
import { useOptimisticUpdate } from '@utils/query';
import { QUERY_KEYS } from '@constants';

type LikedStoryAction = 'unlike';

const LikedStory = (props: StoryProps) => {
  const { id } = props;
  const { t } = useTranslation();

  const { setLoading } = useLoadingStore();

  const optimistic = useOptimisticUpdate();
  const { mutate } = useMutation((id: number) => unlikeStory(id));

  const [actions] = useState<ActionSheetOption<LikedStoryAction>[]>([
    { label: t('삭제하기'), value: 'unlike', isDanger: true },
  ]);

  const handleAction = useCallback(
    (action: LikedStoryAction) => {
      if (action === 'unlike') {
        setLoading(true);
        mutate(id, {
          onSuccess: () => {
            optimistic.remove(QUERY_KEYS.LIKED_STORY.LIST, id);
          },
          onSettled: () => setLoading(false),
        });
      }
    },
    [id]
  );

  return (
    <article css={storyWrapCSS}>
      <Story {...props} />
      <KebabMenu
        css={storyActionCSS}
        name={`liked-story-${id}`}
        options={actions}
        onSelect={handleAction}
      />
    </article>
  );
};

export default LikedStory;
